import _ from 'lodash'
import templateUrl from './roles.capabilities.html'

/**
 * Administer Roles
 *
 * @namespace routes.AdminRoles
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.roles.capabilities',
  label: 'ADMIN.ROLES.ROLECAPABILITIES.TITLE',
  url: '/roles/capabilities',
  component: 'tmrAdminRolesCapabilities',
  accessControl: ['Resource.Role.edit'],
  resolve: {
    capabilities: /*@ngInject*/ TmrCapabilities => TmrCapabilities.get(),
    groups: /*@ngInject*/ (TmrCapabilities, capabilities) =>
      TmrCapabilities.group(capabilities),
    roles: /*@ngInject*/ Role => Role.query().$promise,
    modelsByRole: /*@ngInject*/ (TmrCapabilities, groups, roles) => {
      let models = {}
      roles.forEach(
        role =>
          (models[role.id] = TmrCapabilities.groupModels(
            groups,
            role.capabilities
          ))
      )
      return models
    },
  },
}

/**
 * Component for {@link routes.tmrAdminRolesCapabilities Administer Roles Capabilities route}
 *
 * @type {ngComponent}
 */
export const tmrAdminRolesCapabilities = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminRolesCapabilitiesController',
  bindings: {
    capabilities: '<',
    groups: '<',
    roles: '<',
    modelsByRole: '<',
  },
}

/**
 * Controller of component {@link tmrAdminRolesCapabilities}.
 *
 * @type {ngController}
 */
export class tmrAdminRolesCapabilitiesController {
  static ngType = 'controller'

  constructor(TmrToast, Role) {
    'ngInject'
    Object.assign(this, { TmrToast, Role })
  }

  toggleCapability(role, capability) {
    _.toggle(role.capabilities, capability)
  }

  toggleGroup(role, group) {
    this.toggleCapability(role, group)
    this.groups[group].capabilities.forEach(capability => {
      if (role.capabilities.indexOf(capability.capability) == -1) {
        this.modelsByRole[role.id][capability.capability] = true
        role.capabilities.push(capability.capability)
      }
    })
  }

  onSubmit() {
    return this.Role.bulkUpdate(this.roles).$promise.then(
      () => this.TmrToast.success('ADMIN.ROLES.ROLECAPABILITIES.SUCCESS'),
      err => this.TmrToast.exception(err)
    )
  }
}
